export default __webpack_public_path__ + "static/media/TradersScreen.46140479.png";